var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StoryEdit',{attrs:{"story-id":_vm.storyId}})
}
var staticRenderFns = []

export { render, staticRenderFns }